import { toggleModal } from '../../Store/layoutSlice';
import SubmitButton from '../FormElements/SubmitButton';
import { useDispatch } from 'react-redux';
import * as React from 'react';

export const DeleteForm = ({ onSubmit, inProgress, headerText, submitText }) => {
  const dispatch = useDispatch();
  return (
    <div>
      <form onSubmit={onSubmit}>
        <h6 className="h6  text-danger">{headerText}</h6>
        <div className="modal-footer mt-lg-4 d-flex justify-content-around">
          <button
            onClick={() => dispatch(toggleModal())}
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Mégse
          </button>
          <SubmitButton
            dataTestId={'deleteForm'}
            className={'btn btn-primary'}
            text={submitText}
            inProgress={inProgress}
            disabled={inProgress}
          />
        </div>
      </form>
    </div>
  );
};
